import { render, staticRenderFns } from "./TheNoPermission.vue?vue&type=template&id=66c92932&scoped=true&"
import script from "./TheNoPermission.vue?vue&type=script&lang=js&"
export * from "./TheNoPermission.vue?vue&type=script&lang=js&"
import style0 from "./TheNoPermission.vue?vue&type=style&index=0&id=66c92932&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c92932",
  null
  
)

export default component.exports